import React from 'react';
import "./Footer.css"
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faSyringe, faMotorcycle} from '@fortawesome/free-solid-svg-icons'
const Footer = () => {
    return (
        <div className="footer text-center">
            <h4 className="footer-icon">
              <a target="_blank" href="https://www.linkedin.com/in/iasir-arafat-riaz-a5a4811b8/">
                <i class="fab fa-linkedin"></i> {" "}
              </a>
              <a target="_blank" href="https://github.com/Iasir-Arafat-riaz">
                <i class="fab fa-github"></i>{" "}
              </a>
              <a target="_blank" href=" https://twitter.com/Arafat_Riaz_CSE">
                <i class="fab fa-twitter"></i>{" "}
              </a>
              <a target="_blank" href="https://www.facebook.com/profile.php?id=100059987543734">
                <i class="fab fa-facebook"></i>{" "}
              </a>
              All right reserved by iasir arafat riaz @2021 
            </h4>
            {/* <h4 className="text-center"><i class="fab fa-linkedin"></i> <i class="fab fa-github"></i> <i class="fab fa-twitter"></i> <i class="fab fa-facebook"></i> All right reserved by iasir arafat riaz @2021 </h4> */}
        </div>
    );
};

export default Footer;